import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import axios from "axios";
import Moment from 'react-moment';

import ReactLoading from 'react-loading';
import exportValue from '../../apiconfig'
import Barcode from 'react-barcode';

const Print_receipts = () => {
  const location = useLocation()
  const { shipment_id } = useParams()
  console.log("shipment_id", shipment_id)



  const [state, setState] = React.useState({ shipment_list: [] })
  console.log("state", state)
  const [dimensionState, setdimensionState] = React.useState({ companyDetail: [] })


  React.useEffect(() => {
    dimension_detail()
    shipment_detail()

  }, [])

  const shipment_detail = () => {
    let dataToSend = { shipment_id: shipment_id };

    console.log("datatoSend", dataToSend)
    let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/shipment_detail`;

    // console.log("headers => ", config.headers);


    axios.post(full_api, dataToSend, { headers: exportValue.headers })
      .then((res) => {
        console.log("responseJson => ", res);
        setState({ shipment_list: res.data.output })



      })
      .catch((error) => {
        //Hide Loader
        //   setLoadingstate({...loadingstate,loading:false})
        console.log(error);
      });

  }
  const dimension_detail = () => {

    let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/company_info_api`;
    let sendData = {};

    axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
      setdimensionState({ ...dimensionState, companyDetail: res.data.companyDetail });
      console.log("rnmmmmm", res);
    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      console.log("----error:   ", e);
    })
  }
  //  const  FunctionComponent = () => {
  //     return <Barcode value={shipment_id} />;
  // };

  return (

    <div style={{
      fontSize: "12px",
      margin: "0",
      padding: "3mm",
      background: "rgba(235,235,235,1)",
      backgroundColor: "rgba(235,235,235,1)",
      fontFamily: "arial,sans-serif",
      lineHeight: "18px",
    }}>
      {state.shipment_list.map((sub) => (
        <div class="container mt-3 wrap" >
          <div class="card mb-1">
            <div class="card-body">
              <div class="text-center mb-3">
                <h3 style={{ fontSize: "1.575rem" }}>TAX INVOICE</h3>
              </div>
              <div class="text-end">
                <h4 style={{ fontSize: "1.35rem" }}>Invoice</h4>
                Invoice Number - {sub.order_number}<br />Invoice Date - <Moment format="MMM DD YYYY">
                  {new Date(sub.created * 1000)}
                </Moment>
              </div>
              <hr />
              <table class="table">
                <tbody>
                  <tr>
                    <td style={{ width: "40%" }}>
                      <div class="mb-3">
                        <h4 style={{ fontSize: "1.35rem" }}>Bill To:</h4>
                        <strong>{sub.receiver.name}</strong><br />
                        {sub.receiver.address}, {sub.receiver.city}, {sub.receiver.state} {sub.receiver.pincode}


                      </div>
                      <div class="mb-3">
                        <h4 style={{ fontSize: "1.35rem" }}>Ship To:</h4>

                        <strong>{sub.receiver.name}</strong><br />
                        {sub.receiver.address}, {sub.receiver.city}, {sub.receiver.state} {sub.receiver.pincode}

                      </div>
                    </td>
                    <td>&nbsp;</td>
                    <td class="text-end">
                      <h4 style={{ fontSize: "1.35rem" }}>Sold By:</h4>

                      <strong>{sub.sender.name}</strong><br />
                      {sub.sender.address}, {sub.sender.city}, {sub.sender.state} {sub.sender.pincode}

                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="table">
                <tbody>
                  <tr>
                    <td>
                      <div>
                        <strong>Payment Method:</strong>
                        {sub.payment_mode == "cod" ? "Cod" : "Prepaid"}
                      </div>
                      <div>
                        <strong>AWB No:</strong>
                        {sub.carrier_tracking_number ? sub.carrier_tracking_number : ""}
                      </div>
                    </td>
                    <td></td>
                    <td class="text-end">
                      <div>
                        <strong>Order Date:</strong>
                        <Moment format="MMM DD YYYY">
                          {new Date(sub.created * 1000)}
                        </Moment>
                      </div>
                      <div>
                        <strong>Shipped By:</strong>
                        {sub.service_provider ? sub.service_provider : sub.carrier_name}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card mb-1">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead class="">
                    <tr>
                      <th>Product Name</th>
                      <th>Product SKU</th>
                      <th>HSN</th>
                      <th>QTY</th>
                      <th>Unit Price</th>
                      <th>Tax Amount</th>
                      <th>GST (value)</th>
                      <th>Total (Including GST)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sub.items.map((item) => (
                      <tr>
                        <td>{item.item_name}</td>
                        <td>-</td>
                        <td>-</td>
                        <td>{item.quantity}</td>
                        <td>{item.item_value}</td>
                        <td>-</td>
                        <td>-</td>
                        <td>Rs. {item.item_value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card mb-1">
            <div class="card-body">
              <div class="row justify-content-end">
                <div class="col-8">
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Charges Applied</th>
                          <th>Tax Amount</th>
                          <th>IGST Value(%)</th>
                          <th>Total (Including GST)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Shipping Charges</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                        <tr>
                          <td>COD Charges</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="fw-bold">Amount Due</td>
                          <td>Rs. {sub.items.reduce((total, sub) => total + parseFloat(sub.item_value), 0).toFixed(2)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=''>This is a computer-generated invoice ,  no signature is required.</div>
        </div>

      ))}

    </div>


  )
}

export default Print_receipts



